const FrameRowSelect = (props) => {
  const item = props.item;
  // const { item } = props;

  const handleChange = (id, field, newValue) => {
    props.onChange(id, field, newValue);
  };

  return (
    <div className="loadRow">
      <label htmlFor={item.id}>{item.descr}</label>
      <select
        id={item.id}
        value={item.value}
        onChange={(e) => handleChange(item.id, 'value', e.target.value)}
      >
        <option value="5">5</option>
        <option value="6">5+</option>
        <option value="7">7</option>
        <option value="8">7+</option>
        <option value="9">9</option>
        <option value="10">9+</option>
        <option value="11">11</option>
        <option value="12">11+</option>
        <option value="13">13</option>
      </select>
    </div>
  );
};

export default FrameRowSelect;
